import { SVG, SVGProps } from './svg'

export function IconToolPitchFork(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="m10.35 14.65 7 7-.7.7-7-7 .7-.7zM11 23a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm11-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-7-10a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm13.24-4.54-11.89 11.9-.7-.71 11.88-11.9a.5.5 0 0 1 .71.71zm-4.52-4.47-7.37 7.36-.7-.7L17 5.28a.5.5 0 1 1 .7.71zm9 9-7.37 7.36-.7-.7L26 14.28a.5.5 0 1 1 .7.71z" />
    </SVG>
  )
}
